// Shrink a customer's phone photo in the browser before it goes up with an enquiry:
// a 4000 px HEIC/JPEG becomes a ~300 KB JPEG, which keeps the request small and the
// email under Resend's limits. Orientation comes from the EXIF data where the browser
// supports it (every current phone browser does).
const MAX_EDGE = 1600;
const QUALITY = 0.82;

async function loadBitmap(file) {
  if (typeof window.createImageBitmap === 'function') {
    try {
      return await window.createImageBitmap(file, { imageOrientation: 'from-image' });
    } catch {
      /* fall through to <img> */
    }
  }
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('unsupported image')); };
    img.src = url;
  });
}

// Returns { name, type, data (base64, no prefix), width, height, bytes, preview (data URL) }.
export async function shrinkImage(file) {
  const bitmap = await loadBitmap(file);
  const w0 = bitmap.width || bitmap.naturalWidth;
  const h0 = bitmap.height || bitmap.naturalHeight;
  if (!w0 || !h0) throw new Error('unsupported image');
  const scale = Math.min(1, MAX_EDGE / Math.max(w0, h0));
  const w = Math.max(1, Math.round(w0 * scale));
  const h = Math.max(1, Math.round(h0 * scale));
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, w, h);
  ctx.drawImage(bitmap, 0, 0, w, h);
  if (typeof bitmap.close === 'function') bitmap.close();
  const preview = canvas.toDataURL('image/jpeg', QUALITY);
  const data = preview.split(',')[1] || '';
  if (!data) throw new Error('unsupported image');
  return {
    name: (file.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg',
    type: 'image/jpeg',
    data,
    width: w,
    height: h,
    bytes: Math.round(data.length * 0.75),
    preview,
  };
}
